import { PaperAirplaneIcon, PencilSquareIcon, ShareIcon } from "@heroicons/react/24/outline"
import { Dispatch, FC, SetStateAction, useState } from "react"
import { PatientWithLabs } from "../../types/Patient"
import Modal from "../common/Modal"
import { Tooltip } from "../common/Tooltip"
import { PatientForm } from "./PatientForm"

interface PatientDetailsHeaderProps {
  patient: PatientWithLabs
  setIsEmailEditorOpen: Dispatch<SetStateAction<boolean>>
  setIsShareModalOpen: Dispatch<SetStateAction<boolean>>
  isAnonymous?: boolean
}

export const PatientDetailsHeader: FC<PatientDetailsHeaderProps> = ({
  patient,
  setIsEmailEditorOpen,
  setIsShareModalOpen,
  isAnonymous = false,
}) => {
  const [isEditOpen, setIsEditOpen] = useState(false)

  return (
    <>
      <div className="card -mt-8 flex items-center justify-between rounded-none py-1.5 md:rounded-b">
        <div className="flex flex-col items-baseline gap-x-2 sm:flex-row">
          <h2 className="max-w-[60ch] truncate text-lg font-semibold text-gray-900">{patient.name}</h2>
        </div>
        <div className="flex items-center gap-x-2">
          {!isAnonymous && (
            <>
              <Tooltip content="Share">
                <button
                  onClick={() => setIsShareModalOpen(true)}
                  className="focus-visible:ring-primary-600 rounded-full p-1.5 text-gray-400 hover:text-gray-700 focus-visible:ring-1">
                  <ShareIcon className="h-6 w-6 text-inherit" aria-hidden="true" />
                  <span className="sr-only">Share</span>
                </button>
              </Tooltip>
              <Tooltip content="Send message">
                <button
                  onClick={() => setIsEmailEditorOpen(true)}
                  className="focus-visible:ring-primary-600 rounded-full p-1.5 text-gray-400 hover:text-gray-700 focus-visible:ring-1">
                  <PaperAirplaneIcon className="h-6 w-6 text-inherit" aria-hidden="true" />
                  <span className="sr-only">Send message</span>
                </button>
              </Tooltip>
              <Tooltip content="Edit">
                <button
                  onClick={() => setIsEditOpen(true)}
                  className="focus-visible:ring-primary-600 rounded-full p-1.5 text-gray-400 hover:text-gray-700 focus-visible:ring-1">
                  <PencilSquareIcon className="h-6 w-6 text-inherit" aria-hidden="true" />
                  <span className="sr-only">Edit</span>
                </button>
              </Tooltip>
            </>
          )}
        </div>
      </div>
      {!isAnonymous && (
        <Modal open={isEditOpen} setOpen={setIsEditOpen}>
          <PatientForm patient={patient} handleClose={() => setIsEditOpen(false)} />
        </Modal>
      )}
    </>
  )
}
